/** Поддерживаемые языки интерфейса. */
export const LANGUAGES = ['en', 'ru', 'be'];
/** language_code Telegram → поддерживаемый язык; всё прочее — английский. */
export function normalizeLanguage(code) {
    const base = (code ?? '').toLowerCase().split(/[-_]/)[0] ?? '';
    return LANGUAGES.includes(base) ? base : 'en';
}
//# sourceMappingURL=dto.js.map